import { render } from "./CardTag.vue?vue&type=template&id=1c1e432b&ts=true"
import script from "./CardTag.vue?vue&type=script&lang=ts"
export * from "./CardTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__